// 9fbef606107a605d69c0edbcd8029e5d
import {
  getDateObject,
  getAPIConfig,
  getStringAcronym,
  DIMENSION92_TEXT,
} from '@tcp/core/src/utils/utils';
import { readCookie, setCookie } from '@tcp/core/src/utils/cookie.util';
import { executeExternalAPICall } from '@tcp/core/src/services/handler';
import logger from '@tcp/core/src/utils/loggerInstance';
import buildDYRequest, { buildDYTrackRequest } from './utils/dyRequestBuilder';

export function parseDescription(desc) {
  if (!desc) return {};

  return desc.split(';').reduce((acc, item) => {
    const [key, value] = item.split(':');
    if (key && value) {
      acc[key.trim()] = value.trim();
    }
    return acc;
  }, {});
}

function getDYRecAnalyticsIdentifier(component, page) {
  let pageName = page;
  if (page.indexOf('home') > -1) {
    pageName = 'homepage';
  }

  const recAcronym = getStringAcronym(component);
  const pageAcronym = getStringAcronym(pageName);
  let recAnalyticsIdentifier = `${DIMENSION92_TEXT}${recAcronym}`;
  if (recAcronym?.indexOf(pageAcronym) < 0) {
    recAnalyticsIdentifier = `${DIMENSION92_TEXT}${pageAcronym}`;
  }
  recAnalyticsIdentifier = recAnalyticsIdentifier.replace('homepage', 'hp');
  return recAnalyticsIdentifier;
}

export function parseDyResponseGrouped(response, pageName) {
  if (!response?.choices?.length) return {};

  const groupedProducts = {};

  response.choices.forEach((choice) => {
    const choiceName = choice.name || 'unknown_choice';
    const dyRecsId = getDYRecAnalyticsIdentifier(choiceName, pageName);
    const decsId = choice?.decisionId || '';

    choice.variations.forEach((variation) => {
      const products =
        variation.payload?.data?.slots?.map((slot) => ({
          name: slot?.productData?.name,
          price: slot?.productData?.price || 0,
          salePrice: slot?.productData?.sale_price || 0,
          generalProductId: slot?.productData?.group_id,
          ratings: slot?.productData?.bv_ratings,
          reviewsCount: slot?.productData?.bv_review_count,
          tcpStyleQty: slot?.productData?.style_qty,
          tcpStyleType: slot?.productData?.style_type,
          productFamily: slot?.productData?.product_family,

          ...parseDescription(slot?.productData.description),
          dyRecsId,
          recSlotId: slot?.slotId,
          decsId,
        })) || [];

      groupedProducts[choiceName] = {
        data: products,
        analyticsData: variation?.analyticsMetadata || null,
        title: variation.payload.data.custom?.title || '',
      };
    });
  });

  return groupedProducts;
}

export const getCookieValue = (key = '') => {
  const cookieValue = readCookie(key);
  let value = '';
  if (cookieValue && cookieValue !== 'null' && cookieValue !== 'undefined') {
    value = cookieValue;
  }

  return value;
};

export const parseAndSetCookieOrSessionValue = ({ cookies, dyId, dySession }) => {
  if (dyId && dySession) return;
  if (!cookies) return;

  const serverCookie = cookies.find((c) => c.name === '_dyid_server');
  const sessionCookie = cookies.find((c) => c.name === '_dyjsession');

  if (!dyId && serverCookie) {
    setCookie({
      key: '_dyid_server',
      value: serverCookie.value || '',
      daysAlive: 365,
    });
  }

  if (!dySession && sessionCookie) {
    setCookie({ key: '_dyjsession', value: sessionCookie?.value || '' });
  }
};

export async function getDyRecommendations(payload) {
  const { pageType = '', groups = [], data = [], pageName, pageAttributes } = payload;
  const apiConfigObj = getAPIConfig();
  const { dyURL, dyAPIKey, locale } = apiConfigObj;

  const ip = getCookieValue('tcpIp');
  const dyId = getCookieValue('_dyid_server');
  const dySession = getCookieValue('_dyjsession');

  const reqBody = buildDYRequest({
    data,
    userId: dyId,
    sessionId: dySession,
    pageType,
    pageName,
    pageLocation: window?.location?.href,
    locale,
    groups,
    userAgent: navigator?.userAgent,
    ip,
    dateTime: getDateObject().toISOString(),
    consent: false,
    pageAttributes,
  });

  return executeExternalAPICall({
    webService: {
      method: 'POST',
      URI: dyURL,
    },
    body: reqBody,
    header: {
      'dy-api-key': dyAPIKey,
      accept: 'application/json',
      'content-type': 'application/json',
    },
  })
    .then((res) => {
      const response = res?.body;
      parseAndSetCookieOrSessionValue({ cookies: response?.cookies, dyId, dySession });
      return parseDyResponseGrouped(response, pageName);
    })
    .catch((err) => {
      logger.error('Error occurred in dyRecommendations at getDyRecommendations method -', {
        error: err,
        extraData: {
          payloadRecieved: payload,
        },
      });
      return {};
    });
}

export async function sendDyTrackEvent(payload) {
  const { recSlotId = '', decsId = '' } = payload;
  const apiConfigObj = getAPIConfig();
  const { dyAPIKey, locale, dyTrackURL } = apiConfigObj;

  const ip = getCookieValue('tcpIp');
  const dyId = getCookieValue('_dyid_server');
  const dySession = getCookieValue('_dyjsession');

  const reqBody = buildDYTrackRequest({
    userId: dyId,
    sessionId: dySession,
    pageLocation: window?.location?.href,
    locale,
    userAgent: navigator?.userAgent,
    ip,
    dateTime: getDateObject().toISOString(),
    consent: false,
    recSlotId,
    decsId,
  });

  return executeExternalAPICall({
    webService: {
      method: 'POST',
      URI: dyTrackURL,
    },
    body: reqBody,
    header: {
      'dy-api-key': dyAPIKey,
    },
  })
    .then((res) => {
      const response = res?.body;
      parseAndSetCookieOrSessionValue({ cookies: response?.cookies, dyId, dySession });
      return '';
    })
    .catch((err) => {
      logger.error('Error occurred in dyRecommendations at buildDYTrackRequest method -', {
        error: err,
        extraData: {
          payloadRecieved: payload,
        },
      });
      return {};
    });
}
